module.exports = __webpack_public_path__ + "static/media/WhatWeDo1.7fb7bc89.svg";